/**
 * 课程中心
 */

 import {
    get,
    post,
    put,
    del
  } from '@/util/request'

  /**
   * 根据Id查询
   * @param {*} Id
   * @returns
   */
  export const SelectCourseById = (Id) => {
    return get('/api/app/Course?CurrentId=' + Id);
  }

  /**
   * 新增数据记录
   * @param {*} data
   * @returns
   */
  export const AddCourse = (data) => {
    return post('/api/app/Course', data, {});
  }

  /**
   * 更新数据记录
   * @param {*} data
   * @returns
   */
  export const ModifyCourse = (data) => {
    return put('/api/app/Course', data, {});
  }

  /**
   * 分页获取
   * @param {*} data
   * @returns
   */
  export const GetDataCourseList = (data) => {
    return post('/api/app/Course/list', data, {});
  }


  /**
   * 链表分页获取
   * @param {*} data
   * @returns
   */
   export const GetDataCourseListByPageQuery = (data) => {
    return post('/api/app/Course/getDataByPageQuery', data, {});
  }

  /**
   * 删除记录
   * @param {*} id
   * @returns
   */
  export const DeleteCourse = (id) => {
    return del('/api/app/Course/' + id, {}, {});
  }

    /**
   * 保存课程以及课程章节信息
   * @param {*} data
   * @returns
   */
     export const SaveCourseData = (data) => {
      return post('/api/app/Course/saveCourseData', data, {});
    }

    /* 批量删除 */
    export const DeleteCourses = (data) => {
      return post('/api/app/course/delCourses', data, {});
    }